function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.08,7.52,18,.4A1.54,1.54,0,0,0,17,0H9.63A3.7,3.7,0,0,0,6,3.75V5.3H3.63A3.69,3.69,0,0,0,0,9.05V23.37A3.69,3.69,0,0,0,3.68,27H15.77a3.83,3.83,0,0,0,3.73-3.75V21.7h2.37A3.7,3.7,0,0,0,25.5,18V8.53A1.54,1.54,0,0,0,25.08,7.52ZM18,2.56,22.85,7.4h-2.7A2.19,2.19,0,0,1,18,5.15ZM15.74,25.5H3.7a2.21,2.21,0,0,1-1.53-.61,2.26,2.26,0,0,1-.67-1.64V9a2.21,2.21,0,0,1,.61-1.57A2.26,2.26,0,0,1,3.75,6.8l6.75,0v3.66a3.69,3.69,0,0,0,3.64,3.76H18v9A2.32,2.32,0,0,1,15.74,25.5ZM12,7.86l4.85,4.84h-2.7A2.19,2.19,0,0,1,12,10.45ZM21.86,20.2H19.5V13.83a1.54,1.54,0,0,0-.42-1L12,5.7a1.54,1.54,0,0,0-1-.4H7.5V3.74a2.21,2.21,0,0,1,.61-1.57A2.26,2.26,0,0,1,9.75,1.5l6.75,0V5.14A3.69,3.69,0,0,0,20.12,8.9H24V18A2.2,2.2,0,0,1,21.86,20.2Z"
});

var SvgCopy = function SvgCopy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.5,
    height: 27,
    viewBox: "0 0 25.5 27",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy.106c1d21.svg";
export { ForwardRef as ReactComponent };